import { axiosFinancial, createAuthHeaders } from "./financialApi";

export interface AutocompleteOption {
  label: string;
  value: string | number;
}

export const searchPromoters = async (query: string): Promise<AutocompleteOption[]> => {
  const response = await axiosFinancial.get("/api/consignado/autocomplete/promoters", {
    params: { q: query },
    headers: createAuthHeaders(),
  });
  return response.data;
};

export const searchCorbans = async (query: string): Promise<AutocompleteOption[]> => {
  const response = await axiosFinancial.get("/api/consignado/autocomplete/corbans", {
    params: { q: query },
    headers: createAuthHeaders(),
  });
  return response.data;
};

export const searchCommercialManagers = async (query: string): Promise<AutocompleteOption[]> => {
  const response = await axiosFinancial.get("/api/consignado/autocomplete/commercial-managers", {
    params: { q: query },
    headers: createAuthHeaders(),
  });
  return response.data;
};
